import { render } from "./NodeUpdateForm.vue?vue&type=template&id=2b985a5b"
import script from "./NodeUpdateForm.vue?vue&type=script&lang=js"
export * from "./NodeUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__